import { AxiosResponse } from 'axios'
import apiRequest from '@/apiRequest'
import ApiRequestPaths from '@/apiRequestPaths'

export interface ImageDetailsParams {
  catalogId: string
  imageId: string
}
export default class ImageApiRequest {
  static async getImageFoundElements(imageDetailsRequest: ImageDetailsParams): Promise<AxiosResponse<any>> {
    const imageFoundElements = new URL(
      ApiRequestPaths.GET_IMAGE_FOUND_ELEMENTS
        .replace('{catalogId}', imageDetailsRequest.catalogId)
        .replace('{imageId}', imageDetailsRequest.imageId),
      `${process.env.VUE_APP_API_URL}/api/`,
    )

    return apiRequest.get<any>(imageFoundElements.href)
  }
}
